export const ROOT = '/';

export const LOGIN = 'login';

export const MODEL = 'model';
export const MODELS = 'models';
export const MODEL_NAME = 'modelName';

export const PROMPTS = 'prompts';
export const PROMPT = 'prompt';
export const PROMPT_ID = 'promptId';

export const CREATOR = 'creator';
export const CREATOR_USERNAME = 'creatorUsername';

export const APP = 'app';
export const TEXT_TO_IMAGE = 'text-to-image';

export const CANVASES = 'canvases';
export const STUDIO = 'studio';
export const CANVAS_ID = 'canvasId';
export const PUBLIC_CANVAS = 'public';
export const ACCOUNT = 'account';

export const PROFILE = 'profile';
export const PROFILE_HANDLE = 'profileHandle';

export const HISTORY = 'history';

export const BUY_CREDITS = 'buy_credits';
export const PRICING = 'pricing';
export const PAYMENT_SUCCESSFUL = 'payment-success';
export const PAYMENT_ERROR = 'payment-error';

export const MY_CHARACTERS = 'my-characters';
export const API = 'api';

export const PRIVACY_POLICY = 'https://affogato.ai/privacy-policy';
export const TERMS_AND_CONDITIONS = 'https://affogato.ai/terms-and-conditions';

export const TWITTER = 'https://twitter.com/rendernet_ai';
export const YOUTUBE = 'https://www.youtube.com/@rendernet_ai';
export const DISCORD = 'https://discord.gg/rendernet-ai';
export const REDDIT = 'https://www.reddit.com/r/rendernet/';
export const INSTAGRAM = 'https://www.instagram.com/rendernet.ai/';
export const EMAIL = 'hello@affogato.ai';
export const VIDEO_GUIDE =
	'https://rendernet.notion.site/Narrator-Samples-Tricks-8f22b4fe65d949b38ca31cebd72004be?pvs=4';
export const NOT_FOUND = '404';
export const QUICK_START = 'quick-start';
export const HOME = 'home';
export const VIDEO_ANYONE_GUIDE =
	'https://rendernet.notion.site/Video-Anyone-Guide-127db41d8b2f8094a4dbe0e84521b3a8?pvs=4';
export const MUSIC_VIDEO_GUIDE =
	'https://rendernet.notion.site/Music-Video-Tips-Sample-Outputs-162db41d8b2f80e0bccacc9186ba6982?pvs=4';
export const DESKTOP_NEW_TAB = 'new-tab';
export const DESKTOP_LOGIN = 'desktop-login';

export const PRODUCT_PHOTO_GUIDE =
	'https://rendernet.notion.site/Product-Photo-Guide-196db41d8b2f80179c2bd3b4e261c69d?pvs=4';

export const CREATIVE_GUIDE =
	'https://rendernet.notion.site/RenderNet-Creative-Guide-1aedb41d8b2f80e595e1d4f23779e607?pvs=4';
